import React from "react";

import Button, { ButtonTypes } from "../Button";
import { DateFormat, formatCurrency, formatDate } from "../../utils";
import { ADJUSTMENT_LABEL } from "./constants";
import {
  AdjustmentActions,
  AdjustmentAmount,
  AdjustmentList as List,
  AdjustmentMeta,
  AdjustmentRow,
  AdjustmentSummary,
  AdjustmentTitle,
} from "./styles";
import { CashbackAdjustmentListProps } from "./types";

export const CashbackAdjustmentList: React.FC<CashbackAdjustmentListProps> = ({
  adjustments,
  onDelete,
}) => (
  <List aria-label="Balance corrections">
    {adjustments.map((adjustment) => {
      const date = formatDate(adjustment.adjustmentDate, DateFormat.DMY_SPACE);
      return (
        <AdjustmentRow key={adjustment.id}>
          <AdjustmentSummary>
            <AdjustmentTitle>
              {date} · {ADJUSTMENT_LABEL}
            </AdjustmentTitle>
            {adjustment.note && (
              <AdjustmentMeta>{adjustment.note}</AdjustmentMeta>
            )}
          </AdjustmentSummary>
          <AdjustmentActions>
            <AdjustmentAmount>
              {formatCurrency(adjustment.amount)}
            </AdjustmentAmount>
            <Button
              type={ButtonTypes.link}
              size="small"
              tone="danger"
              aria-label={`Delete ${ADJUSTMENT_LABEL.toLowerCase()} from ${date}`}
              onClick={() => onDelete(adjustment)}
            >
              Delete
            </Button>
          </AdjustmentActions>
        </AdjustmentRow>
      );
    })}
  </List>
);
